import { useTranslation } from 'react-i18next'
import { StatusPill, type Tone } from '../DeliveryStatusBadge'
import { isUnfinished, type ReportStatus } from '@/services/reports/reportsApi'

/** Being built is blue and pulsing, done is green, anything else went wrong. */
const STATUS_TONES: Record<ReportStatus, Tone> = {
  PENDING: 'blue',
  QUEUED: 'blue',
  PROCESSING: 'blue',
  COMPLETED: 'green',
  REJECTED: 'red',
  FAILED: 'red',
  CANCELLED: 'gray',
  TIMED_OUT: 'red',
}

/** Where a report has got to, in the same pill every other status wears. */
export function ReportStatusPill({ status }: { status: ReportStatus }) {
  const { t } = useTranslation()
  const tone = STATUS_TONES[status] ?? 'gray'
  return (
    <StatusPill tone={tone} pulse={isUnfinished(status)}>
      {t(`reports.status.${status}`)}
    </StatusPill>
  )
}
